// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateViewerModal_modalOverlay__JYzaE {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.94);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  backdrop-filter: blur(12px);
  padding: 24px;
  animation: CertificateViewerModal_fadeIn__l9ST- 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
@media (max-width: 768px) {
  .CertificateViewerModal_modalOverlay__JYzaE {
    padding: 0;
  }
}

.CertificateViewerModal_modalContent__oGDcK {
  background-color: transparent;
  width: 100%;
  max-width: 1400px;
  height: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: CertificateViewerModal_zoomIn__kvI-L 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
@media (max-width: 768px) {
  .CertificateViewerModal_modalContent__oGDcK {
    max-height: 100vh;
  }
}

.CertificateViewerModal_closeButton__bIG-0 {
  position: absolute !important;
  top: -48px;
  right: -10px;
  color: #fff !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(8px);
  z-index: 20;
  padding: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}
.CertificateViewerModal_closeButton__bIG-0:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.1);
}
.CertificateViewerModal_closeButton__bIG-0 svg {
  font-size: 24px;
}
@media (max-width: 768px) {
  .CertificateViewerModal_closeButton__bIG-0 {
    top: 16px;
    right: 16px;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
}

.CertificateViewerModal_modalBody__BfWvK {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
}
@media (max-width: 768px) {
  .CertificateViewerModal_modalBody__BfWvK {
    border-radius: 0;
    border: none;
  }
}

.CertificateViewerModal_imageViewer__rOnRM {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
  display: block;
}

.CertificateViewerModal_pdfViewer__\\+SQpb {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #f1f1f1;
  border-radius: 12px;
}

.CertificateViewerModal_modalCaption__hQrrh {
  color: #fff;
  text-align: center;
  padding: 16px 0 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  opacity: 0.8;
}

@keyframes CertificateViewerModal_fadeIn__l9ST- {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes CertificateViewerModal_zoomIn__kvI-L {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/CertificateViewerModal/CertificateViewerModal.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,aAAA;EACA,kFAAA;AACJ;AACI;EAfJ;IAgBQ,UAAA;EAEN;AACF;;AACA;EACI,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kFAAA;AAEJ;AAAI;EAXJ;IAYQ,iBAAA;EAGN;AACF;;AAAA;EACI,6BAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,qDAAA;EACA,0BAAA;EACA,WAAA;EACA,uBAAA;EACA,qDAAA;AAGJ;AADI;EACI,qDAAA;EACA,qBAAA;AAGR;AAAI;EACI,eAAA;AAER;AACI;EApBJ;IAqBQ,SAAA;IACA,WAAA;IACA,+CAAA;EAEN;AACF;;AACA;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AAEJ;AAAI;EAXJ;IAYQ,gBAAA;IACA,YAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;AAGJ;;AAAA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AAGJ;;AAAA;EACI;IAAO,UAAA;EAIT;EAHE;IAAK,UAAA;EAMP;AACF;AAJA;EACI;IACI,sBAAA;IACA,UAAA;EAMN;EAJE;IACI,mBAAA;IACA,UAAA;EAMN;AACF","sourcesContent":[".modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.94);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n    backdrop-filter: blur(12px);\n    padding: 24px;\n    animation: fadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n\n    @media (max-width: 768px) {\n        padding: 0;\n    }\n}\n\n.modalContent {\n    background-color: transparent;\n    width: 100%;\n    max-width: 1400px;\n    height: 100%;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    animation: zoomIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n\n    @media (max-width: 768px) {\n        max-height: 100vh;\n    }\n}\n\n.closeButton {\n    position: absolute !important;\n    top: -48px;\n    right: -10px;\n    color: #fff !important;\n    background-color: rgba(255, 255, 255, 0.1) !important;\n    backdrop-filter: blur(8px);\n    z-index: 20;\n    padding: 8px !important;\n    border: 1px solid rgba(255, 255, 255, 0.2) !important;\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2) !important;\n        transform: scale(1.1);\n    }\n\n    svg {\n        font-size: 24px;\n    }\n\n    @media (max-width: 768px) {\n        top: 16px;\n        right: 16px;\n        background-color: rgba(0, 0, 0, 0.5) !important;\n    }\n}\n\n.modalBody {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    position: relative;\n\n    @media (max-width: 768px) {\n        border-radius: 0;\n        border: none;\n    }\n}\n\n.imageViewer {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    border-radius: 4px;\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);\n    display: block;\n}\n\n.pdfViewer {\n    width: 100%;\n    height: 100%;\n    border: none;\n    background-color: #f1f1f1;\n    border-radius: 12px;\n}\n\n.modalCaption {\n    color: #fff;\n    text-align: center;\n    padding: 16px 0 0;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    opacity: 0.8;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes zoomIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `CertificateViewerModal_modalOverlay__JYzaE`,
	"fadeIn": `CertificateViewerModal_fadeIn__l9ST-`,
	"modalContent": `CertificateViewerModal_modalContent__oGDcK`,
	"zoomIn": `CertificateViewerModal_zoomIn__kvI-L`,
	"closeButton": `CertificateViewerModal_closeButton__bIG-0`,
	"modalBody": `CertificateViewerModal_modalBody__BfWvK`,
	"imageViewer": `CertificateViewerModal_imageViewer__rOnRM`,
	"pdfViewer": `CertificateViewerModal_pdfViewer__+SQpb`,
	"modalCaption": `CertificateViewerModal_modalCaption__hQrrh`
};
export default ___CSS_LOADER_EXPORT___;
